/** First path segment of a router URL — the analytics "module" a navigation lands in.
 * The raw url carries query strings (a campaign-tagged root landing is `/?utm_source=…`) and can
 * carry fragments and matrix params; none of them are part of WHERE the visitor landed. */
export function moduleFromUrl(urlAfterRedirects: string): string {
  const path = urlAfterRedirects.split('?')[0].split('#')[0];
  const segment = path.split('/')[1] ?? '';
  return segment.split(';')[0] || 'portal';
}
